export function normalizeValue(val) {
  if (typeof val === "string") {
    const unquoted = val.replace(/^['"](.*)['"]$/s, "$1").trim()
    if (unquoted.toLowerCase() === "true") return true
    if (unquoted.toLowerCase() === "false") return false
    if (!isNaN(unquoted) && unquoted !== "") return Number(unquoted)
    return unquoted
  }
  if (Array.isArray(val)) return val.map(normalizeValue)
  if (val && typeof val === "object") {
    return Object.fromEntries(
      Object.entries(val).map(([k, v]) => [k, normalizeValue(v)])
    )
  }
  return val
}
